import { NgIf } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { GalleryAccessLevel, GalleryDto, GalleryPublicAccessLevel } from '@picflow/types';
import { Subscription } from 'rxjs';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { DialogService, OnGetData } from 'src/app/services/dialog.service';
import { GalleryService } from 'src/app/services/gallery.service';
import { TenantService } from 'src/app/services/tenant.service';
import { StickyFooterItem } from 'src/app/shared-extra/components/sticky-footer/sticky-footer.component';
import { DialogModeSwitcherComponent } from '../../../shared-extra/components/dialog-mode-switcher/dialog-mode-switcher.component';
import { StickyFooterComponent } from '../../../shared-extra/components/sticky-footer/sticky-footer.component';
import { ResizeDirective } from '../../../shared/directives/resize.directive';
import { ShareGalleryEmbedComponent } from '../../components/share-gallery-embed/share-gallery-embed.component';
import { ShareSubGalleryLinkComponent } from '../../components/share-sub-gallery-link/share-sub-gallery-link.component';
import { ShareGalleryDialogComponent } from '../share-gallery-dialog/share-gallery-dialog.component';
import { WorkspaceDialogComponent } from '../workspace-dialog/workspace-dialog.component';

@Component({
  selector: 'app-share-sub-gallery-dialog',
  templateUrl: './share-sub-gallery-dialog.component.html',
  styleUrls: ['./share-sub-gallery-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    ResizeDirective,
    DialogModeSwitcherComponent,
    ShareSubGalleryLinkComponent,
    ShareGalleryEmbedComponent,
    StickyFooterComponent,
  ],
})
export class ShareSubGalleryDialogComponent implements OnGetData, OnDestroy {
  dialogName = 'share-sub-gallery';
  gallery: GalleryDto;
  close: (...args) => void;
  accessLevel: GalleryAccessLevel;
  publicAccessLevel: GalleryPublicAccessLevel;
  canShare = navigator.share && ScreenSizes.screenSize() !== 'desktop';
  hideAll = false;
  updateSub: Subscription;

  mode: 'link' | 'embed' = 'link';
  menuItems: StickyFooterItem[] = [
    {
      key: 'link',
      icon: 'link',
      text: 'Gallery Link',
    },
    {
      key: 'embed',
      icon: 'code-circle',
      text: 'Embed Code',
    },
  ];

  dialogOptions(): DialogOptions {
    return { size: 560, hideClose: true, spacingX: 40, spacingY: 40, minHeight: 440 };
  }

  constructor(
    private dialog: DialogService,
    private galleryService: GalleryService,
    private tenantService: TenantService
  ) {}

  async onGetData(data: { gallery: GalleryDto }, close: (...args) => void) {
    if (this.tenantService.shouldShowWorkspaceDialog(data.gallery)) {
      this.hideAll = true;
      return this.dialog.open(WorkspaceDialogComponent, {
        onDone: () => this.dialog.open(ShareGalleryDialogComponent, data),
        gallery: data.gallery,
      });
    }
    this.gallery = data.gallery;
    this.close = close;

    this.updateSub = this.galleryService.onUpdates.subscribe(event => {
      if (!event) return;
      if (event[1] !== this.gallery.id) return;
      if (event[0] === 'deleted') this.close();
    });
  }

  ngOnDestroy(): void {
    this.updateSub?.unsubscribe();
  }
}
